import { call, put, takeLatest } from "redux-saga/effects";

import { USER } from "../actions";
import generateAction from "../../utils/action-helpers";

import { setHeader } from "../../api/configure-axios";

import { getCurrent, fetchUsers, addUser, editUser, deleteUser } from "../../api/user";

import redirectToLogin from "../../utils/redirect-to-login";

function* login(action) {
  const token = action.payload;
  try {
    if (token) {
      yield call(setHeader, "auth", token);
      const response = yield call(getCurrent);
      yield put(generateAction(USER.LOGIN_SUCCESS, response.data));
    } else {
      redirectToLogin();
    }
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(USER.LOGIN_ERROR));
  }
}

function* fetch() {
  try {
    const response = yield call(fetchUsers);
    yield put(generateAction(USER.FETCH_SUCCESS, response.data));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(USER.FETCH_ERROR));
  }
}

function* add(action) {
  const { user, users } = action.payload;
  try {
    const response = yield call(addUser, user);
    yield put(generateAction(USER.FETCH_SUCCESS, [...users, response.data]));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(USER.FETCH_ERROR));
  }
}

function* edit(action) {
  const { users, index, user } = action.payload;
  try {
    const response = yield call(editUser, user);
    const newUsers = [...users];
    newUsers.splice(index, 1, response.data);
    yield put(generateAction(USER.FETCH_SUCCESS, newUsers));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(USER.FETCH_ERROR));
  }
}

function* deleteSaga(action) {
  const { users, index } = action.payload;
  try {
    const user = users[index];
    yield call(deleteUser, user);
    const newUsers = [...users];
    newUsers.splice(index, 1);
    yield put(generateAction(USER.FETCH_SUCCESS, newUsers));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(USER.FETCH_ERROR));
  }
}

export default function* usersSaga() {
  yield takeLatest(USER.LOGIN, login);
  yield takeLatest(USER.FETCH, fetch);
  yield takeLatest(USER.ADD, add);
  yield takeLatest(USER.EDIT, edit);
  yield takeLatest(USER.DELETE, deleteSaga);
}
